// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1xfXK","productName":"Table_productName__3nJs8"};